import { useEffect } from "react";

const KEYS = {
  clarity: "logcomex:integrations:clarity",
  ga4: "logcomex:integrations:ga4",
  gsc: "logcomex:integrations:gsc",
  plausible: "logcomex:integrations:plausible",
};

function loadScript(id: string, src: string, attrs: Record<string, string> = {}) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.async = true;
  s.src = src;
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
  document.head.appendChild(s);
}

function injectInline(id: string, code: string) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.innerHTML = code;
  document.head.appendChild(s);
}

function injectMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}

export function AnalyticsLoader() {
  useEffect(() => {
    // Microsoft Clarity
    const clarityId = localStorage.getItem(KEYS.clarity);
    if (clarityId) {
      injectInline(
        "ms-clarity",
        `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "${clarityId}");`
      );
    }

    // GA4
    const gaId = localStorage.getItem(KEYS.ga4);
    if (gaId) {
      loadScript("ga4-src", `https://www.googletagmanager.com/gtag/js?id=${gaId}`);
      injectInline(
        "ga4-init",
        `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}');`
      );
    }

    // Google Search Console (meta verification)
    const gscToken = localStorage.getItem(KEYS.gsc);
    if (gscToken) injectMeta("google-site-verification", gscToken);

    // Plausible
    const plausibleDomain = localStorage.getItem(KEYS.plausible);
    if (plausibleDomain) {
      loadScript("plausible", "https://plausible.io/js/script.js", {
        "data-domain": plausibleDomain,
        defer: "true",
      });
    }
  }, []);

  return null;
}

export const INTEGRATION_KEYS = KEYS;
